import Vue from 'vue';
import Router from 'vue-router';
import { authenticated, empty, is_staff } from './utils/router';
import ResetPasswordLink from './views/ResetPasswordLink.vue';
import SpacesMilestones from './views/SpacesMilestones.vue';
import SpacesSettings from './views/SpacesSettings.vue';
import AdminDashboard from './views/AdminDashboard.vue';
import SpacesContent from './views/SpacesContent.vue';
import ResetPassword from './views/ResetPassword.vue';
import SpacesFlow from './views/SpacesFlow.vue';
import Settings from './views/Settings.vue';
import Confirm from './views/Confirm.vue';
import Signin from './views/Signin.vue';
import Signup from './views/Signup.vue';
import Spaces from './views/Spaces.vue';
import Teams from './views/Teams.vue';

Vue.use(Router);

export default new Router({
    linkActiveClass: 'is-active',
    routes: [{
        path: '/',
        name: 'home',
        redirect: { name: 'signin' },
    }, {
        path: '/signin',
        name: 'signin',
        component: Signin,
    }, {
        path: '/signup/:invitation_key?',
        name: 'signup',
        component: Signup,
    }, {
        path: '/confirm/:code',
        name: 'confirm',
        component: Confirm,
    }, {
        path: '/reset_password',
        name: 'reset_password_link',
        component: ResetPasswordLink,
    }, {
        path: '/reset_password/:code',
        name: 'reset_password',
        component: ResetPassword,
    }, {
        path: '/app/teams',
        name: 'teams',
        component: Teams,
        beforeEnter: authenticated,
    }, {
        path: '/app/spaces',
        name: 'spaces',
        component: Spaces,
        beforeEnter: authenticated,
    }, {
        path: '/app/settings',
        name: 'settings',
        component: Settings,
        beforeEnter: authenticated,
    }, {
        path: '/app/spaces/:space/settings',
        name: 'space_settings',
        component: SpacesSettings,
        beforeEnter: authenticated,
    }, {
        path: '/app/spaces/:space/content',
        name: 'content',
        component: SpacesContent,
        beforeEnter: authenticated,
    }, {
        path: '/app/spaces/:space/flow/:flow',
        name: 'flow',
        component: SpacesFlow,
        beforeEnter: authenticated,
    }, {
        path: '/app/spaces/:space/milestones',
        name: 'milestones',
        component: SpacesMilestones,
        beforeEnter: authenticated,
    }, {
        path: '/app/admin',
        component: empty,
        beforeEnter: is_staff,
        children: [{
            path: 'dashboard',
            name: 'admin_dashboard',
            component: AdminDashboard,
            beforeEnter: authenticated,
        }],
    }],
});
